<template>
    <v-container fluid>   
      <v-layout row wrap>        
        <v-flex xs12>
          <v-data-table
            :headers="headersSalary"
            :items="salariesFormatted"
            :items-per-page="50"
            item-key="validityFrom"
            sort-by="validityFrom"
            :sort-desc="true"
            class="elevation-1"
            :search="search"
            :custom-filter="filterOnlyCapsText"
            hide-default-footer
            >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Salary History</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialogSalary" max-width="900px">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on">New Salary</v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm6 md6>
                            <DatePicker picker-label="Valid From" :date-value="editedItem.validityFrom" @dateSelected="editedItem.validityFrom=$event" />
                          </v-flex> 
                          <v-flex xs12 sm6 md6>
                            <DatePicker picker-label="Valid Until" :date-value="editedItem.validityUntil" @dateSelected="editedItem.validityUntil=$event" />
                          </v-flex> 
                          <v-flex xs12 sm6 md6>
                            <v-currency-field :key="editedItem.id" v-model="editedItem.amount" label="Amount"></v-currency-field>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-combobox
                            :items="currencyListWithText"
                            label="Select Currency"
                            v-model="editedItem.currency"
                            item-text="text"
                            single-line
                            return-object
                          ></v-combobox>
                          </v-flex>                                                                                                                                                                                                                         
                        </v-layout>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="error" dark class="mb-2" @click="closeSalary">Cancel</v-btn>
                      <v-btn color="success" dark class="mb-2" @click="saveSalary">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
              <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
            </template> 
            <template v-slot:body.append>                    
            </template>             
            <template v-slot:item.action="{ item }">              
              <v-icon                  
                @click="editItem(item)">
                mdi-table-edit
              </v-icon>
              <v-icon                  
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
</template>
<script>
import formatPrice from '../helpers/formatter';
import formatToDouble from '../helpers/formatToDouble';
import DatePicker from '../components/DatePicker';
const API_URL = 'definitions/';
const PERSONNEL_API_URL = 'definitions/personnel/';
const CURRENCIES_API_URL = 'definitions/currencies';

export default {
    name : 'PersonnelSalaries',
    props: {
    },
    components:{
      DatePicker
    },
    data () {
    return {
      dialogSalary: false,
      search: '',
      currencyList: [],   
      personnelSalaries: [],   
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
    }
  },
  computed: {
    headersSalary () {
      return [
        { text: 'Valid From', align: 'center', sortable: true, value: 'validityFrom' },
        { text: 'Valid Until', align: 'center', sortable: true, value: 'validityUntil' },
        { text: 'Amount',  align: 'right', value: 'amountFormatted' , sort: (a, b) =>  formatToDouble(a) - formatToDouble(b) },             
        { text: 'Currency', value: 'currency.code' },
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    salariesFormatted(){
      return this.personnelSalaries.map((item) => {
        item.amountFormatted = formatPrice(item.amount);
        return item;  
      })
    },
    currencyListWithText(){
      return this.currencyList.map((item) => {
        return {
          id: item.id,
          code: item.code,
          text: item.code+' - '+item.text          
        };
      })
    },   
    formTitle () {
      return this.editedIndex === -1 ? 'New Salary' : 'Edit Salary'
    },
  },
  created() {    
    this.getSalaryHistory();
    this.getCurrencies();
  },
  watch: {
    dialogSalary (val) {
      val || this.closeSalary()
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.personnelSalaries.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogSalary = true
    },      
    deleteItem(item) {
      if(confirm('Are you sure you want to delete this item?')){
        this.deleteSalary(item);
      } 
    },
    getSalaryHistory(){     
      this.$axios.get(this.$apiurl + PERSONNEL_API_URL+this.$route.params.id+'/salaries')
          .then(response => {
              this.personnelSalaries = response.data
          }) 
          .catch(error => {
              console.log(error);
          });                         
    }, 
    saveSalary () {
      if (this.editedIndex > -1) {        
        this.updateSalary(this.editedItem);
      } else {
        this.addSalary(this.editedItem);         
      }      
    },
    addSalary(item){
      this.$axios.post(this.$apiurl + API_URL+'personnelSalaries', {
        id : -1,
        personnelId : this.$route.params.id,
        validityFrom: item.validityFrom,
        validityUntil: item.validityUntil,
        currencyId: item.currency.id,
        amount: item.amount,
      })
      .then(response => {        
        if (response.status === 201) {
          this.personnelSalaries.push(this.editedItem);            
          this.closeSalary();         
          this.$radio.$emit('success', {message:'Personnel Salary Added Successfully'});
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },      
    updateSalary(item){
      this.$axios.put(this.$apiurl + API_URL+'personnelSalaries', {
        id: item.id,
        personnelId : this.$route.params.id,
        validityFrom: item.validityFrom,
        validityUntil: item.validityUntil,
        currencyId: item.currency.id,
        amount: item.amount,
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.personnelSalaries[this.editedIndex], this.editedItem);            
          this.closeSalary();
          this.$radio.$emit('success', {message:'Personnel Salary Updated Successfully'});
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },      
    deleteSalary(item){
      this.$axios.delete(this.$apiurl + API_URL+'personnelSalaries/'+item.id)
      .then(response => {
        if (response.status === 200) {
          const index = this.personnelSalaries.indexOf(item)
          this.personnelSalaries.splice(index, 1);
          this.$radio.$emit('success', {message:'Personnel Salary Deleted Successfully'});
        }
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },            
    closeSalary () {
      this.dialogSalary = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },    
    getCurrencies(){     
      this.$axios.get(this.$apiurl + CURRENCIES_API_URL)
          .then(response => {
              this.currencyList = response.data
          }) 
          .catch(error => {
              console.log(error);
          });                         
    },      
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
